import { useCallback, useEffect } from 'react';

import classNames from 'classnames';

import type { UnifiedEvent } from 'src/app/analytics/analyticsEvents';
import { UNIFIED } from 'src/app/analytics/analyticsEvents';
import { ArchiveSectionContainer } from 'src/app/components/Elements/ArchiveSection/index';
import { EmptyStateCard } from 'src/app/components/Elements/Card/EmptyStateCard';
import StandardPage from 'src/app/components/Elements/Page/Standard';
import Spinner from 'src/app/components/Elements/Spinner';
import { Typography } from 'src/app/components/Elements/Typography';
import { segmentTrack } from 'src/app/state/actions';
import {
  getArchivedMedications,
  getIsFetchingArchivedMedications,
  loadArchivedMedications,
} from 'src/app/state/slices/archivedMedications';
import { useSelector, useDispatch } from 'src/app/state/store';
import type { HomeArchivedItem } from 'src/app/types';

import styles from '../Medications/styles.module.scss';

export const ArchivedPrescriptions = () => {
  const dispatch = useDispatch();
  const dispatchSegmentTrack = useCallback(
    (event: UnifiedEvent, payload) => dispatch(segmentTrack(event, payload)),
    [dispatch]
  );

  const dispatchFetchArchivedPrescriptions = useCallback(() => dispatch(loadArchivedMedications()), [dispatch]);

  useEffect(() => {
    dispatchSegmentTrack(UNIFIED.viewArchivedMedications, { source: 'Menu' });
    dispatchFetchArchivedPrescriptions();
  }, [dispatchFetchArchivedPrescriptions, dispatchSegmentTrack]);
  const archivedHomescreenMedications: HomeArchivedItem[] = useSelector(getArchivedMedications)!;
  const isFetching = useSelector(getIsFetchingArchivedMedications);
  return (
    <>
      <StandardPage alignment={'left'}>
        <div className={classNames(styles.medicationHeaderWrapper)}>
          <Typography variant={'h1'} marginBottom={'s3'}>
            Archived prescriptions
          </Typography>
        </div>
        {isFetching && <Spinner centered />}
        {!isFetching && (
          <div className={styles.component}>
            {archivedHomescreenMedications?.length > 0 && (
              <ArchiveSectionContainer
                archivedHomescreenItems={archivedHomescreenMedications}
                hasMultiplePatients={true}
              />
            )}
            {archivedHomescreenMedications?.length === 0 && (
              <EmptyStateCard
                height={32}
                image={<img src={'/public/archived-rx.svg'} alt="Archived Prescription Icon" />}
                text="You have no archived prescriptions."
                textStyle="grayNormal"
              />
            )}
          </div>
        )}
      </StandardPage>
    </>
  );
};
